import { environment } from 'src/environments/environment';

export const enum Language {
  RU = 'ru',
  EN = 'en',
}

export const APP_CONFIG = {
  baseUrl: !!environment.baseUrl
    ? environment.baseUrl
    : `${window.location.protocol.replace('app:', 'https:')}//${window.location.host}`, // TODO: hack для мобильных приложений и копирования внутренних ссылок в приложении
  messenger: {
    baseUrl: '', // TODO: заполняется отдельным запросом в main.ts
  },
  localizations: [Language.RU, Language.EN],
  defaultLocale: Language.RU,
  loadingLimit: {
    chats: 1000,
    messages: 30,
    chatMembers: 200,
    organisations: 50,
    users: 50,
  },
  dictionaries: {
    externalTypeIdIcon: '@tui.folder',
    noNameGroup: '( Без названия )',
  },
  fileSizeMax: {
    image: 10 * 1000 * 1000, // 10 Мб
    doc: 50 * 1000 * 1000, // 50 Мб
  },
  fileTypes: {
    audio: ['.m4a', '.mp3', '.wav'],
    video: ['.avi', '.avchd', '.flv', '.mov', '.mp4'],
    image: ['.gif', '.jpg', '.jpeg', '.png', '.svg'],
    textDocument: ['.doc', '.docx', '.htm', '.html', '.pdf', '.txt', '.xls', '.xlsx'],
    excelDocument: ['.xls', '.xlsx'],
  },
  folders: {
    unions: {
      title: 'Unions',
      iconName: 'Work',
    },
    notUnions: {
      title: 'Без unions',
      iconName: 'Custom',
    },
  },
  searchMinLength: 2,
  yaMapAPIKey: 'a616135c-fbd8-4ffe-8ebc-e00f4a8cf4d1',
  yandexMetrikaId: '',
  alertAutoclose: 3000,

  // TODO: Удалить, когда будет решён вопрос с отображением лого в ПЛ #13213
  isBrand: ![
    'lk.unions.me',
    'beta.unions.me',
    'localhost',
    'test-unions.techsrv.ru',
    'test-unions-1.techsrv.ru',
    'test-unions-2.techsrv.ru',
    'test-unions-3.techsrv.ru',
    'test-unions-4.techsrv.ru',
    'dev-unions.techsrv.ru',
    'ad.techsrv.ru',
    'ad-target.techsrv.ru',
  ].includes(window.location.hostname),
};
